const { currencyFilter } = require('@/vue/filters/currencyFilter');
const { toInt } = require('@/functions/transform');
const { toNullableFloat } = require('@/functions/transform');

/**
 * @constructor
 */
const FieldOption = function () {
    /**
     * @type {Number}
     */
    this.ID = null;

    /**
     * Incorrectly named ID field for backward compatibility.
     *
     * @type {number}
     */
    this.fieldOptionID = 0;

    /**
     * @type {Number}
     */
    this.fieldID = null;

    /**
     * @type {string}
     */
    this.name = '';

    /**
     * @type {number|null}
     */
    this.price = null;

    /**
     * @type {Number}
     */
    this.navOrder = null;
};

FieldOption.prototype = {
    getHydrationMap() {
        return {
            fieldID: toInt,
            ID: {
                field: ['ID', 'fieldOptionID'],
                transform: toInt,
            },
            // Incorrectly named ID field for backward compatibility.
            fieldOptionID: {
                field: ['ID', 'fieldOptionID'],
                transform: toInt,
            },
            name: {},
            navOrder: toInt,
            price: toNullableFloat,
            status: {},
        };
    },

    get priceStringForSelectLabel() {
        if (!this.price) {
            return '';
        }

        if (this.price < 0) {
            return '(- ' + currencyFilter(Math.abs(this.price)) + ')';
        }

        return '(+ ' + currencyFilter(this.price) + ')';
    },
};

module.exports = FieldOption;
